<template>
  <ZtLink class="teaser is-quarter" :to="url">
    <div class="teaser-media">
      <slot name="media">
        <div
          v-blokkli-droppable:[editableConfig?.image]
          class="image aspect-4/3"
        >
          <MediaImage v-bind="media" responsive-style="column_quarter" />
        </div>
      </slot>
    </div>
    <h2
      v-blokkli-editable:[editableConfig?.title]
      class="title"
      v-html="title"
    />
    <p
      v-if="tagline"
      v-blokkli-editable:[editableConfig?.tagline]
      class="subtitle mb-0"
      v-html="tagline"
    />
    <slot />
  </ZtLink>
</template>

<script lang="ts" setup>
import type { TeaserProps } from './types'

withDefaults(defineProps<TeaserProps>(), {
  title: '',
  tagline: '',
  text: '',
  url: '',
  linkTitle: '',
  media: undefined,
  showTagline: false,
  zurichCardTeaser: false,
})
</script>

<style>
@reference '~/assets/css/tailwind.css';
.teaser.is-quarter {
  @apply text-size-7;
  .title,
  .subtitle {
    @apply text-size-7;
    @apply tablet:text-size-6;
  }
  .title {
    @apply mt-size-7 mb-0;
  }
  .teaser-text {
    @apply mb-size-6;
  }
}
</style>
